/**
 * Card-sizer wiring for the Manual Card Elementor widget.
 *
 * See project memory "Elementor custom widget JS init pattern" for why
 * this specific `frontend/element_ready` + `elementor/frontend/init`
 * shape (not a DOMContentLoaded scan, not a bare `.hooks.addAction()`) is
 * required — verified against Elementor 4.2.1's actual source after
 * several real bugs surfaced building the YouTube Feed widget.
 */
( function () {
	'use strict';

	function registerElementReadyHook() {
		window.elementorFrontend.hooks.addAction( 'frontend/element_ready/gws-manual-card.default', function ( $scope ) {
			var card = $scope[ 0 ].querySelector( '.gws-card' );

			if ( card && window.GWSInitCardSizer ) {
				window.GWSInitCardSizer( card );
			}
		} );
	}

	if ( window.elementorFrontend && window.elementorFrontend.hooks ) {
		registerElementReadyHook();
	} else {
		window.addEventListener( 'elementor/frontend/init', registerElementReadyHook );
	}
} )();
